import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  AbstractProdForm,
  ProdFormButton,
  ProdFormField,
  ProdFormFieldType,
  ProdFormValidators,
  RequiredValidator,
  EmailValidator
} from 'prod-form';
import {ProdDialogData, ProdDialogService} from 'prod-dialog';
import {ProdGridColumnType} from 'prod-grid';
import {HttpFilterParam} from "prod-shared";
import {Role} from "../../../../dip/role";
import {UserFormComponent} from "../../../users/form/user-form.component";
import {RoleService} from "../../../../services/role.service";
import {UserService} from "../../../../services/user.service";
import {UserGroupService} from "../../../../services/user-group.service";
import {OrganizationTreeSelect} from "../../../../dip/organization-tree-select";
import {DipColumn} from "../../../../dip/dip-column";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-distributor-user-form',
  templateUrl: './distributor-user-form.component.html'
})
export class DistributorUserFormComponent extends AbstractProdForm {
  title: string = this.translate.instant('user.form.title');
  private isFieldsEditable: boolean = this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN]);
  fields: ProdFormField[] = [
    ProdFormField.create({
      type: ProdFormFieldType.TEXT,
      name: 'username',
      label: this.translate.instant('user.form.username'),
      validators: new ProdFormValidators([
        new RequiredValidator(), new EmailValidator()
      ]),
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      type: ProdFormFieldType.TEXT,
      name: 'firstName',
      label: this.translate.instant('user.form.first_name'),
      validators: new ProdFormValidators([
        new RequiredValidator(),
      ]),
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      type: ProdFormFieldType.TEXT,
      name: 'lastName',
      label: this.translate.instant('user.form.last_name'),
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      type: ProdFormFieldType.GRID,
      name: 'groups',
      label: this.translate.instant('user.form.groups'),
      gridParameter: {
        displayColumn: DipColumn.get({property: 'name', type: ProdGridColumnType.STRING}),
        service: UserGroupService,
        extraColumns: [
          DipColumn.get({property: 'organizationUserGroup.organization.name', type: ProdGridColumnType.STRING}),
        ]
      },
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      type: ProdFormFieldType.HIDDEN,
      name: 'organization',
      label: '',
    })
  ];
  formButtons: ProdFormButton[] = [
    new ProdFormButton({
      id: 'reset-password-button',
      text: this.translate.instant('user.form.reset_password_button'),
      clickEvent: this.resetPassword.bind(this)
    })
  ];

  constructor(
    public dialogRef: MatDialogRef<UserFormComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: ProdDialogData,
    override dataService: UserService,
    private dialogService: ProdDialogService,
    private organizationTreeSelect: OrganizationTreeSelect,
    private roleService: RoleService,
    private translate: TranslateService) {
      super();
  }

  ngOnInit() {
    const distributor = this.data.extraData.distributor;

    this.fields.forEach(field => {
      if (field.name === 'groups') field.gridParameter.filter = new HttpFilterParam({
        property: 'organizationUserGroup.organization',
        operator: 'eq',
        value: distributor
      });
      if (field.name === 'organization') {
        field.value = distributor
      }
    })

    this.formButtons[0].disabled = !this.isFieldsEditable || this.data.records && this.data.records.getSize() > 1 || !this.data.records;
  }

  resetPassword() {
    let userId: number;
    this.data.records.getAll().forEach(r => userId = r.id);
    this.dataService.newPasswordRequest(userId).subscribe(res => {
      if (res && res['success']) {
        this.dialogService.alert({
          message: this.translate.instant('user.form.reset_password.success_message'),
          title: this.translate.instant('general.success')
        })
      }
    });
  }
}
